/** Textos do portal de administração (consola de operações ZRS). */
const pt = {
    // Acesso
    "admin.backToSite": "Voltar ao site",
    "admin.brand.tag": "Ops console",
    "admin.loginTitle": "Portal de operações",
    "admin.login.text": "Acesso reservado à staff da ZRS. Entra com a tua conta Discord para continuar.",
    "admin.login.discord": "Entrar com Discord",
    "admin.login.redirecting": "A abrir o Discord…",
    "admin.login.failed": "Não foi possível iniciar o login com o Discord. Tenta outra vez.",
    "admin.login.note2fa": "Ativa a autenticação de dois fatores (2FA) na tua conta Discord.",
    "admin.login.noteRoles": "Só contas com papel admin ou owner veem o painel. Todas as ações ficam na auditoria.",
    "admin.login.signedAs": "Sessão: {name}",
    "admin.notConfiguredTitle": "Portal indisponível",
    "admin.notConfigured": "Supabase não está configurado neste ambiente.",
    "admin.forbiddenTitle": "Sem permissão",
    "admin.forbidden": "Esta conta não tem acesso de administração.",
    "admin.refresh": "Atualizar",
    "admin.signOut": "Sair",
    "admin.markReviewed": "Marcar como revisto",

    // Navegação
    "admin.nav.label": "Secções do portal",
    "admin.nav.overview": "Visão geral",
    "admin.nav.overviewDesc": "Pulso do site, do servidor e da comunidade",
    "admin.nav.security": "Segurança",
    "admin.nav.securityDesc": "Alertas do ZaroAI em tempo real e saúde do sistema",
    "admin.nav.players": "Jogadores",
    "admin.nav.playersDesc": "Contas registadas, bans e papéis",
    "admin.nav.vip": "VIP",
    "admin.nav.vipDesc": "Pedidos do simulador VIP",
    "admin.nav.zaro": "ZaroAI",
    "admin.nav.zaroDesc": "Uso do assistente e conversas do site",
    "admin.nav.audit": "Auditoria",
    "admin.nav.auditDesc": "Registo imutável das ações da staff",
    "admin.nav.openAlerts": "alertas por rever",
    "admin.nav.collapse": "Recolher menu",
    "admin.nav.expand": "Expandir menu",
    "admin.top.skip": "Saltar para o conteúdo",
    "admin.top.clockHint": "Hora de Brasília (America/Sao_Paulo)",
    "admin.top.serverHint": "Jogadores online no servidor",
    "admin.live.connecting": "A ligar…",
    "admin.live.live": "Ao vivo",
    "admin.live.polling": "Atualização a cada 30 s",
    "admin.live.connectingHint": "A ligar ao canal de alertas em tempo real.",
    "admin.live.liveHint": "Alertas de segurança chegam em tempo real.",
    "admin.live.pollingHint": "Tempo real indisponível: os dados são atualizados a cada 30 segundos.",
    "admin.live.toastTitle": "Novo alerta {severity}",
    "admin.live.toastAction": "Ver",

    // Comum
    "admin.common.loading": "A carregar…",
    "admin.common.retry": "Tentar outra vez",
    "admin.common.cancel": "Cancelar",
    "admin.common.close": "Fechar",
    "admin.common.clear": "Limpar",
    "admin.common.copy": "Copiar",
    "admin.common.copied": "Copiado.",
    "admin.common.copyFailed": "Não foi possível copiar.",
    "admin.common.unknown": "Desconhecido",
    "admin.common.you": "Tu",
    "admin.common.newTab": "abre num novo separador",
    "admin.common.pagination": "Paginação",
    "admin.common.prev": "Página anterior",
    "admin.common.next": "Página seguinte",
    "admin.common.range": "{from}–{to} de {total}",

    // Erros
    "admin.error.title": "Não foi possível carregar os dados.",
    "admin.error.missingTitle": "Migração em falta: {file}",
    "admin.error.missingHint": "Aplica o ficheiro em supabase/migrations no SQL Editor do Supabase e atualiza.",
    "admin.error.forbiddenTitle": "Sem permissão no Supabase",
    "admin.error.forbiddenHint": "Confirma o papel admin/owner em app_metadata e se as migrações do portal estão aplicadas.",
    "admin.error.networkTitle": "Sem ligação",
    "admin.error.networkHint": "Verifica a ligação à internet e tenta outra vez.",
    "admin.error.actionFailed": "A ação falhou. Tenta outra vez.",

    // Papéis e gravidade
    "admin.role.member": "Membro",
    "admin.role.moderator": "Moderador",
    "admin.role.admin": "Admin",
    "admin.role.owner": "Owner",
    "admin.severity.critical": "Crítico",
    "admin.severity.high": "Alto",
    "admin.severity.medium": "Médio",
    "admin.severity.low": "Baixo",
    "admin.kind.prompt_injection": "Tentativa de prompt injection",
    "admin.kind.hacking_request": "Tentativa de hacking / extração de dados",
    "admin.kind.output_leak_blocked": "Fuga de informação bloqueada",
    "admin.kind.cheating_request": "Pedido de batota",
    "admin.kind.unsafe_content": "Conteúdo impróprio",
    "admin.kind.rate_limit_abuse": "Excesso de mensagens",
    "admin.filter.open": "Por rever",
    "admin.filter.all": "Todos",

    // Visão geral
    "admin.overview.eyebrow": "Consola de operações",
    "admin.overview.morning": "Bom dia, {name}",
    "admin.overview.afternoon": "Boa tarde, {name}",
    "admin.overview.evening": "Boa noite, {name}",
    "admin.overview.pulseOnline": "Servidor online · {n} a jogar",
    "admin.overview.pulseOffline": "Servidor offline",
    "admin.overview.pulseAlerts": "{n} alertas por rever",
    "admin.overview.pulseNoAlerts": "Sem alertas por rever",
    "admin.overview.pulseSignups": "{n} novos registos em 7 dias",
    "admin.overview.updated": "Estatísticas às {when}",
    "admin.overview.last14": "Últimos 14 dias",
    "admin.overview.today": "Hoje",
    "admin.overview.noData14": "Sem atividade nos últimos 14 dias.",
    "admin.overview.chartAria": "{title}: {total} nos últimos 14 dias, pico de {peak} num dia",
    "admin.overview.activity": "Atividade recente",
    "admin.overview.noActivity": "Ainda sem atividade.",
    "admin.overview.partial": "Algumas fontes não responderam; a lista pode estar incompleta.",
    "admin.overview.feedSignup": "{name} registou-se no site",
    "admin.overview.feedVip": "{name} simulou o {vip} ({value})",
    "admin.overview.feedAlert": "{kind} · {name}",
    "admin.overview.ordersTitle": "Encomendas e comunidade",
    "admin.overview.noOrders": "Sem encomendas registadas.",
    "admin.overview.staff": "Staff",
    "admin.overview.banned": "Banidos",
    "admin.overview.new24h": "Novos (24h)",
    "admin.overview.shortcuts": "Atalhos de teclado",
    "admin.orders.draft": "Rascunho",
    "admin.orders.pending_payment": "A aguardar pagamento",
    "admin.orders.paid": "Pago",
    "admin.orders.fulfilled": "Entregue",
    "admin.orders.cancelled": "Cancelado",
    "admin.orders.refunded": "Reembolsado",
    "admin.kpi.playersOnline": "Jogadores online",
    "admin.kpi.serverDown": "Sem resposta do servidor",
    "admin.kpi.users": "Registados",
    "admin.kpi.new7d": "+{n} em 7 dias",
    "admin.kpi.steam": "Steam ligada",
    "admin.kpi.steamSub": "{n} contas com SteamID",
    "admin.kpi.vip7d": "Pedidos VIP (7d)",
    "admin.kpi.vipValue": "{value} estimados",
    "admin.kpi.zaro24h": "ZaroAI · 24h",
    "admin.kpi.tokens": "{n} tokens",
    "admin.kpi.alerts": "Alertas abertos",
    "admin.kpi.alerts24h": "{n} nas últimas 24h",
    "admin.chart.signups": "Registos",
    "admin.chart.zaro": "Perguntas ao ZaroAI",
    "admin.chart.alerts": "Alertas de segurança",
    "admin.chart.vip": "Pedidos VIP",

    // Servidor
    "admin.server.title": "Servidor ao vivo",
    "admin.server.online": "Online",
    "admin.server.offline": "Offline",
    "admin.server.stale": "Dados antigos",
    "admin.server.unknown": "Sem dados",
    "admin.server.players": "Jogadores",
    "admin.server.queue": "{n} na fila",
    "admin.server.lastSeen": "Último sinal {when}",
    "admin.server.uptime": "Uptime",
    "admin.server.lastWipe": "Último wipe",
    "admin.server.nextWipe": "Próximo wipe",
    "admin.server.today": "Hoje",
    "admin.server.daysAgo": "Há {n} dias",
    "admin.server.map": "Mapa",
    "admin.server.openMap": "Abrir mapa",
    "admin.server.connect": "Conectar",
    "admin.server.playersSession": "Jogadores (sessão)",
    "admin.server.fpsSession": "FPS (sessão)",
    "admin.server.samples": "{n} amostras nesta sessão · a cada 30 s",

    // Segurança
    "admin.security.bySeverity": "Alertas abertos por gravidade",
    "admin.security.last24h": "Últimas 24h",
    "admin.security.feed": "Alertas",
    "admin.security.feedLive": "Em tempo real",
    "admin.security.feedPolling": "Atualizado a cada 30 s",
    "admin.security.statusFilter": "Estado",
    "admin.security.severityFilter": "Gravidade",
    "admin.security.kindFilter": "Tipo",
    "admin.security.allSeverities": "Todas as gravidades",
    "admin.security.allKinds": "Todos os tipos",
    "admin.security.search": "Filtrar por jogador, ID ou texto",
    "admin.security.emptyOpen": "Sem alertas por rever. Tudo tranquilo.",
    "admin.security.emptyAll": "Sem alertas com estes filtros.",
    "admin.security.emptyHint": "Os novos alertas aparecem aqui automaticamente.",
    "admin.security.limitNote": "A mostrar os 100 alertas mais recentes. Usa os filtros para refinar.",
    "admin.security.open": "Aberto",
    "admin.security.reviewed": "Revisto",
    "admin.security.new": "Novo",
    "admin.security.alert": "Alerta",
    "admin.security.reopen": "Reabrir",
    "admin.security.reviewedOk": "Alerta marcado como revisto.",
    "admin.security.reopenedOk": "Alerta reaberto.",
    "admin.security.reviewedAt": "Revisto em {when} por {who}",
    "admin.security.excerpt": "Mensagem",
    "admin.security.details": "Detalhes",
    "admin.security.rawJson": "Ver JSON",
    "admin.security.conversation": "Conversa",
    "admin.security.noConversation": "Sem conversa associada a este alerta.",
    "admin.security.lookingUp": "A procurar o perfil…",
    "admin.security.copyDiscord": "Copiar ID Discord",
    "admin.security.viewPlayer": "Ver jogador",
    "admin.security.filterUser": "Ver alertas deste jogador",
    "admin.security.bulk": "Rever {n}",
    "admin.security.bulkTitle": "Marcar {n} alertas como revistos?",
    "admin.security.bulkDesc": "Todos os alertas abertos visíveis com os filtros atuais passam a revistos. Fica registado na auditoria.",
    "admin.security.bulkConfirm": "Marcar como revistos",
    "admin.security.bulkDone": "{n} alertas marcados como revistos.",
    "admin.security.offenders": "Reincidentes (30 dias)",
    "admin.security.offendersSub": "Jogadores com mais alertas",
    "admin.security.noOffenders": "Ninguém com alertas nos últimos 30 dias.",
    "admin.security.alertsCount": "{n} alertas",
    "admin.security.lastAlert": "Último {when}",

    // Banir
    "admin.ban.ban": "Banir",
    "admin.ban.unban": "Desbanir",
    "admin.ban.titleBan": "Banir {name}?",
    "admin.ban.titleUnban": "Desbanir {name}?",
    "admin.ban.descBan": "O jogador deixa de poder usar o chat ZaroAI no site. Podes reverter a qualquer momento.",
    "admin.ban.descUnban": "O jogador volta a poder usar o chat ZaroAI no site.",
    "admin.ban.reason": "Motivo (opcional, fica na auditoria)",
    "admin.ban.reasonPlaceholder": "Ex.: tentativas repetidas de prompt injection",
    "admin.ban.doneBan": "Jogador banido.",
    "admin.ban.doneUnban": "Jogador desbanido.",
    "admin.ban.noProfile": "Sem perfil no site associado.",
    "admin.ban.self": "Não te podes banir a ti próprio.",
    "admin.ban.staff": "Admins e owners não podem ser banidos aqui.",

    // Saúde do sistema
    "admin.health.title": "Saúde do sistema",
    "admin.health.allGood": "Tudo configurado.",
    "admin.health.problems": "{n} pontos a resolver",
    "admin.health.optional": "opcional",
    "admin.health.setEnv": "Define {name} nas variáveis de ambiente da Vercel e faz redeploy.",
    "admin.health.applyMigration": "Aplica supabase/migrations/{file} no SQL Editor do Supabase.",
    "admin.health.needService": "Não verificável sem SUPABASE_SERVICE_ROLE_KEY.",
    "admin.health.zrsDown": "A API do servidor não respondeu ou o servidor está offline.",
    "admin.health.zrsNotConfigured": "API do servidor não configurada.",
    "admin.health.connectDefault": "Sem ZRS_CONNECT_ADDRESS: o botão CONECTAR usa o endereço por omissão.",
    "admin.health.footer": "Verificado às {when} · {ms} ms · região {region} · deploy {deploy}",
    "admin.health.item.supabaseUrl": "URL do Supabase",
    "admin.health.item.serviceRole": "Chave service role (servidor)",
    "admin.health.item.zaroKey": "Chave da IA do ZaroAI",
    "admin.health.item.zrsApi": "API do servidor ZRS",
    "admin.health.item.zrsLive": "Servidor ZRS a responder",
    "admin.health.item.alertWebhook": "Webhook de alertas (Discord)",
    "admin.health.item.connectOverride": "Endereço do botão CONECTAR",
    "admin.health.item.migAlerts": "Migração dos alertas de segurança",
    "admin.health.item.migPortal": "Migração do portal admin",
    "admin.health.state.ok": "OK",
    "admin.health.state.bad": "Em falta",
    "admin.health.state.unknown": "Desconhecido",
    "admin.health.state.optional": "Opcional, não configurado",
    "admin.health.err.network": "Sem ligação ao endpoint de saúde.",
    "admin.health.err.unauthorized": "Sessão expirada. Sai e volta a entrar.",
    "admin.health.err.forbidden": "O servidor recusou: o teu papel não tem acesso.",
    "admin.health.err.missing": "Endpoint /api/admin/health indisponível (só existe no deploy da Vercel).",
    "admin.health.err.rateLimited": "Demasiados pedidos. Espera um minuto.",
    "admin.health.err.generic": "Não foi possível verificar o sistema.",

    // Boas práticas
    "admin.hardening.title": "Checklist de proteção",
    "admin.hardening.authLimits": "Limites e CAPTCHA no Supabase Auth",
    "admin.hardening.authLimitsText": "Em Authentication → Rate Limits / Attack Protection, ativa limites de pedidos e CAPTCHA.",
    "admin.hardening.discord2fa": "2FA no Discord para toda a staff",
    "admin.hardening.discord2faText": "O login do portal é só por Discord: sem 2FA, uma conta roubada dá acesso ao painel.",
    "admin.hardening.rotate": "Rodar chaves ao mínimo sinal",
    "admin.hardening.rotateText": "Service role, chave da IA, token da API e webhook: troca-as se houver suspeita de fuga. Nunca em REACT_APP_*.",
    "admin.hardening.rls": "RLS ativo e migrações aplicadas",
    "admin.hardening.rlsText": "Todas as tabelas com Row Level Security; o caminho do portal não é segredo, a proteção está no RLS.",
    "admin.hardening.leastPrivilege": "Mínimo de admins",
    "admin.hardening.leastPrivilegeText": "Só owners mudam papéis. Dá admin apenas a quem precisa e remove quando deixar a staff.",
    "admin.hardening.auditReview": "Rever a auditoria",
    "admin.hardening.auditReviewText": "Uma vez por semana, confirma bans e mudanças de papel na secção Auditoria.",

    // Jogadores
    "admin.players.title": "Jogadores registados",
    "admin.players.privacy": "Os emails nunca são mostrados neste painel.",
    "admin.players.search": "Nome, utilizador, ID Discord ou SteamID",
    "admin.players.filter": "Filtro de jogadores",
    "admin.players.fAll": "Todos",
    "admin.players.fStaff": "Staff",
    "admin.players.fBanned": "Banidos",
    "admin.players.fSteam": "Com Steam",
    "admin.players.empty": "Nenhum jogador encontrado.",
    "admin.players.emptySearch": "Tenta outro termo ou limpa os filtros.",
    "admin.players.colPlayer": "Jogador",
    "admin.players.colRole": "Papel",
    "admin.players.colJoined": "Registo",
    "admin.players.colActions": "Ações",
    "admin.players.banned": "Banido",
    "admin.players.changeRole": "Mudar papel",
    "admin.players.roleSelf": "Não podes mudar o teu próprio papel aqui.",
    "admin.players.roleTitle": "Mudar o papel de {name}?",
    "admin.players.roleDesc": "De {from} para {to}. A alteração tem efeito no próximo login do jogador e fica na auditoria.",
    "admin.players.roleWarn": "Admins e owners veem dados de todos os jogadores e podem banir. Confirma que confias nesta pessoa.",
    "admin.players.roleConfirm": "Mudar papel",
    "admin.players.roleChanged": "Papel alterado para {role}.",
    "admin.players.roleError.last_owner": "Não é possível remover o último owner.",
    "admin.players.roleError.forbidden": "Só owners podem mudar papéis.",
    "admin.players.roleError.service_role_missing": "Falta SUPABASE_SERVICE_ROLE_KEY no servidor.",
    "admin.players.roleError.rate_limited": "Demasiados pedidos. Espera um minuto.",
    "admin.players.roleError.invalid_input": "Pedido inválido.",
    "admin.players.roleError.update_failed": "O Supabase recusou a alteração.",
    "admin.players.roleError.network": "Sem ligação ao servidor.",
    "admin.players.roleError.missing": "Endpoint /api/admin/role indisponível neste ambiente.",
    "admin.players.roleError.generic": "Não foi possível mudar o papel.",

    // VIP
    "admin.vip.title": "Pedidos do simulador VIP",
    "admin.vip.subtitle": "Valores estimados pelo simulador, em reais.",
    "admin.vip.search": "Jogador ou nome do VIP",
    "admin.vip.empty": "Ainda sem pedidos VIP.",
    "admin.vip.total": "Pedidos (total)",
    "admin.vip.value7d": "Valor estimado (7d)",
    "admin.vip.avgPage": "Ticket médio (página)",
    "admin.vip.pageSum": "{value} nesta página",
    "admin.vip.colTotal": "Total estimado",
    "admin.vip.colBudget": "Orçamento",
    "admin.vip.colDate": "Data",
    "admin.vip.overBudget": "acima do orçamento",
    "admin.vip.expand": "Ver detalhes do pedido",
    "admin.vip.collapse": "Esconder detalhes",
    "admin.vip.items": "Itens ({n})",
    "admin.vip.benefits": "Benefícios ({n})",
    "admin.vip.more": "+{n} itens",
    "admin.vip.noItems": "Sem itens no pedido.",
    "admin.vip.noBenefits": "Sem benefícios extra.",
    "admin.vip.kitTotal": "Kit",
    "admin.vip.benefitsExtra": "Benefícios extra",

    // ZaroAI
    "admin.zaro.questions24h": "Perguntas (24h)",
    "admin.zaro.conversations24h": "Conversas novas (24h)",
    "admin.zaro.activeUsers": "Utilizadores ativos (7d)",
    "admin.zaro.tokens24h": "Tokens (24h)",
    "admin.zaro.latency": "Latência média (24h)",
    "admin.zaro.trendSub": "{n} perguntas nos últimos 14 dias",
    "admin.zaro.conversations": "Conversas do site",
    "admin.zaro.conversationsSub": "Ordenadas pela atividade mais recente",
    "admin.zaro.search": "Título ou ID Discord",
    "admin.zaro.empty": "Ainda sem conversas no site.",
    "admin.zaro.untitled": "Conversa sem título",
    "admin.zaro.startedAt": "Iniciada em {when}",
    "admin.transcript.empty": "Sem mensagens guardadas.",
    "admin.transcript.count": "{n} mensagens",
    "admin.transcript.tokens": "{n} tokens",
    "admin.transcript.player": "Jogador",
    "admin.transcript.ipHashHint": "Prefixo do hash do IP (nunca o IP real), útil para ligar contas do mesmo dispositivo.",

    // Auditoria
    "admin.audit.title": "Registo de auditoria",
    "admin.audit.subtitle": "Quem fez o quê, a quem e quando.",
    "admin.audit.filter": "Filtrar por ação",
    "admin.audit.allActions": "Todas as ações",
    "admin.audit.empty": "Sem ações registadas.",
    "admin.audit.emptyHint": "Bans, revisões de alertas e mudanças de papel aparecem aqui.",
    "admin.audit.immutable": "{n} registos · a auditoria não pode ser editada nem apagada a partir do site.",
    "admin.audit.action.ban": "baniu",
    "admin.audit.action.unban": "desbaniu",
    "admin.audit.action.role_change": "mudou o papel de",
    "admin.audit.action.alert_reviewed": "reviu o alerta",
    "admin.audit.action.alert_reopened": "reabriu o alerta",
    "admin.audit.action.alerts_bulk_reviewed": "reviu vários alertas",
    "admin.audit.target.profile": "Perfil",
    "admin.audit.target.user": "Utilizador",
    "admin.audit.target.security_alert": "Alerta",
};

const en = {
    // Access
    "admin.backToSite": "Back to site",
    "admin.brand.tag": "Ops console",
    "admin.loginTitle": "Operations portal",
    "admin.login.text": "Restricted to ZRS staff. Sign in with your Discord account to continue.",
    "admin.login.discord": "Sign in with Discord",
    "admin.login.redirecting": "Opening Discord…",
    "admin.login.failed": "Couldn't start the Discord sign-in. Please try again.",
    "admin.login.note2fa": "Turn on two-factor authentication (2FA) on your Discord account.",
    "admin.login.noteRoles": "Only admin or owner accounts can see the panel. Every action is audited.",
    "admin.login.signedAs": "Signed in: {name}",
    "admin.notConfiguredTitle": "Portal unavailable",
    "admin.notConfigured": "Supabase is not configured in this environment.",
    "admin.forbiddenTitle": "No permission",
    "admin.forbidden": "This account doesn't have admin access.",
    "admin.refresh": "Refresh",
    "admin.signOut": "Sign out",
    "admin.markReviewed": "Mark as reviewed",

    // Navigation
    "admin.nav.label": "Portal sections",
    "admin.nav.overview": "Overview",
    "admin.nav.overviewDesc": "Pulse of the website, server and community",
    "admin.nav.security": "Security",
    "admin.nav.securityDesc": "Live ZaroAI alerts and system health",
    "admin.nav.players": "Players",
    "admin.nav.playersDesc": "Registered accounts, bans and roles",
    "admin.nav.vip": "VIP",
    "admin.nav.vipDesc": "VIP simulator requests",
    "admin.nav.zaro": "ZaroAI",
    "admin.nav.zaroDesc": "Assistant usage and website conversations",
    "admin.nav.audit": "Audit",
    "admin.nav.auditDesc": "Immutable log of staff actions",
    "admin.nav.openAlerts": "alerts to review",
    "admin.nav.collapse": "Collapse menu",
    "admin.nav.expand": "Expand menu",
    "admin.top.skip": "Skip to content",
    "admin.top.clockHint": "Brasília time (America/Sao_Paulo)",
    "admin.top.serverHint": "Players online on the server",
    "admin.live.connecting": "Connecting…",
    "admin.live.live": "Live",
    "admin.live.polling": "Refreshing every 30 s",
    "admin.live.connectingHint": "Connecting to the real-time alerts channel.",
    "admin.live.liveHint": "Security alerts arrive in real time.",
    "admin.live.pollingHint": "Real time unavailable: data refreshes every 30 seconds.",
    "admin.live.toastTitle": "New {severity} alert",
    "admin.live.toastAction": "View",

    // Common
    "admin.common.loading": "Loading…",
    "admin.common.retry": "Try again",
    "admin.common.cancel": "Cancel",
    "admin.common.close": "Close",
    "admin.common.clear": "Clear",
    "admin.common.copy": "Copy",
    "admin.common.copied": "Copied.",
    "admin.common.copyFailed": "Couldn't copy.",
    "admin.common.unknown": "Unknown",
    "admin.common.you": "You",
    "admin.common.newTab": "opens in a new tab",
    "admin.common.pagination": "Pagination",
    "admin.common.prev": "Previous page",
    "admin.common.next": "Next page",
    "admin.common.range": "{from}–{to} of {total}",

    // Errors
    "admin.error.title": "Couldn't load the data.",
    "admin.error.missingTitle": "Missing migration: {file}",
    "admin.error.missingHint": "Run the file from supabase/migrations in the Supabase SQL Editor, then refresh.",
    "admin.error.forbiddenTitle": "No permission in Supabase",
    "admin.error.forbiddenHint": "Check the admin/owner role in app_metadata and that the portal migrations are applied.",
    "admin.error.networkTitle": "No connection",
    "admin.error.networkHint": "Check your internet connection and try again.",
    "admin.error.actionFailed": "The action failed. Please try again.",

    // Roles and severity
    "admin.role.member": "Member",
    "admin.role.moderator": "Moderator",
    "admin.role.admin": "Admin",
    "admin.role.owner": "Owner",
    "admin.severity.critical": "Critical",
    "admin.severity.high": "High",
    "admin.severity.medium": "Medium",
    "admin.severity.low": "Low",
    "admin.kind.prompt_injection": "Prompt injection attempt",
    "admin.kind.hacking_request": "Hacking / data extraction attempt",
    "admin.kind.output_leak_blocked": "Information leak blocked",
    "admin.kind.cheating_request": "Cheating request",
    "admin.kind.unsafe_content": "Unsafe content",
    "admin.kind.rate_limit_abuse": "Message flooding",
    "admin.filter.open": "To review",
    "admin.filter.all": "All",

    // Overview
    "admin.overview.eyebrow": "Operations console",
    "admin.overview.morning": "Good morning, {name}",
    "admin.overview.afternoon": "Good afternoon, {name}",
    "admin.overview.evening": "Good evening, {name}",
    "admin.overview.pulseOnline": "Server online · {n} playing",
    "admin.overview.pulseOffline": "Server offline",
    "admin.overview.pulseAlerts": "{n} alerts to review",
    "admin.overview.pulseNoAlerts": "No alerts to review",
    "admin.overview.pulseSignups": "{n} new sign-ups in 7 days",
    "admin.overview.updated": "Stats as of {when}",
    "admin.overview.last14": "Last 14 days",
    "admin.overview.today": "Today",
    "admin.overview.noData14": "No activity in the last 14 days.",
    "admin.overview.chartAria": "{title}: {total} in the last 14 days, peak of {peak} in a day",
    "admin.overview.activity": "Recent activity",
    "admin.overview.noActivity": "No activity yet.",
    "admin.overview.partial": "Some sources didn't respond; the list may be incomplete.",
    "admin.overview.feedSignup": "{name} signed up on the website",
    "admin.overview.feedVip": "{name} simulated {vip} ({value})",
    "admin.overview.feedAlert": "{kind} · {name}",
    "admin.overview.ordersTitle": "Orders and community",
    "admin.overview.noOrders": "No orders recorded.",
    "admin.overview.staff": "Staff",
    "admin.overview.banned": "Banned",
    "admin.overview.new24h": "New (24h)",
    "admin.overview.shortcuts": "Keyboard shortcuts",
    "admin.orders.draft": "Draft",
    "admin.orders.pending_payment": "Awaiting payment",
    "admin.orders.paid": "Paid",
    "admin.orders.fulfilled": "Fulfilled",
    "admin.orders.cancelled": "Cancelled",
    "admin.orders.refunded": "Refunded",
    "admin.kpi.playersOnline": "Players online",
    "admin.kpi.serverDown": "No response from the server",
    "admin.kpi.users": "Registered",
    "admin.kpi.new7d": "+{n} in 7 days",
    "admin.kpi.steam": "Steam linked",
    "admin.kpi.steamSub": "{n} accounts with a SteamID",
    "admin.kpi.vip7d": "VIP requests (7d)",
    "admin.kpi.vipValue": "{value} estimated",
    "admin.kpi.zaro24h": "ZaroAI · 24h",
    "admin.kpi.tokens": "{n} tokens",
    "admin.kpi.alerts": "Open alerts",
    "admin.kpi.alerts24h": "{n} in the last 24h",
    "admin.chart.signups": "Sign-ups",
    "admin.chart.zaro": "ZaroAI questions",
    "admin.chart.alerts": "Security alerts",
    "admin.chart.vip": "VIP requests",

    // Server
    "admin.server.title": "Live server",
    "admin.server.online": "Online",
    "admin.server.offline": "Offline",
    "admin.server.stale": "Stale data",
    "admin.server.unknown": "No data",
    "admin.server.players": "Players",
    "admin.server.queue": "{n} in queue",
    "admin.server.lastSeen": "Last heartbeat {when}",
    "admin.server.uptime": "Uptime",
    "admin.server.lastWipe": "Last wipe",
    "admin.server.nextWipe": "Next wipe",
    "admin.server.today": "Today",
    "admin.server.daysAgo": "{n} days ago",
    "admin.server.map": "Map",
    "admin.server.openMap": "Open map",
    "admin.server.connect": "Connect",
    "admin.server.playersSession": "Players (session)",
    "admin.server.fpsSession": "FPS (session)",
    "admin.server.samples": "{n} samples this session · every 30 s",

    // Security
    "admin.security.bySeverity": "Open alerts by severity",
    "admin.security.last24h": "Last 24h",
    "admin.security.feed": "Alerts",
    "admin.security.feedLive": "Real time",
    "admin.security.feedPolling": "Refreshed every 30 s",
    "admin.security.statusFilter": "Status",
    "admin.security.severityFilter": "Severity",
    "admin.security.kindFilter": "Type",
    "admin.security.allSeverities": "All severities",
    "admin.security.allKinds": "All types",
    "admin.security.search": "Filter by player, ID or text",
    "admin.security.emptyOpen": "No alerts to review. All quiet.",
    "admin.security.emptyAll": "No alerts match these filters.",
    "admin.security.emptyHint": "New alerts show up here automatically.",
    "admin.security.limitNote": "Showing the 100 most recent alerts. Use the filters to narrow down.",
    "admin.security.open": "Open",
    "admin.security.reviewed": "Reviewed",
    "admin.security.new": "New",
    "admin.security.alert": "Alert",
    "admin.security.reopen": "Reopen",
    "admin.security.reviewedOk": "Alert marked as reviewed.",
    "admin.security.reopenedOk": "Alert reopened.",
    "admin.security.reviewedAt": "Reviewed on {when} by {who}",
    "admin.security.excerpt": "Message",
    "admin.security.details": "Details",
    "admin.security.rawJson": "View JSON",
    "admin.security.conversation": "Conversation",
    "admin.security.noConversation": "No conversation linked to this alert.",
    "admin.security.lookingUp": "Looking up the profile…",
    "admin.security.copyDiscord": "Copy Discord ID",
    "admin.security.viewPlayer": "View player",
    "admin.security.filterUser": "Show this player's alerts",
    "admin.security.bulk": "Review {n}",
    "admin.security.bulkTitle": "Mark {n} alerts as reviewed?",
    "admin.security.bulkDesc": "Every open alert visible with the current filters will be marked as reviewed. This is recorded in the audit log.",
    "admin.security.bulkConfirm": "Mark as reviewed",
    "admin.security.bulkDone": "{n} alerts marked as reviewed.",
    "admin.security.offenders": "Repeat offenders (30 days)",
    "admin.security.offendersSub": "Players with the most alerts",
    "admin.security.noOffenders": "Nobody triggered alerts in the last 30 days.",
    "admin.security.alertsCount": "{n} alerts",
    "admin.security.lastAlert": "Last {when}",

    // Ban
    "admin.ban.ban": "Ban",
    "admin.ban.unban": "Unban",
    "admin.ban.titleBan": "Ban {name}?",
    "admin.ban.titleUnban": "Unban {name}?",
    "admin.ban.descBan": "The player will no longer be able to use the ZaroAI chat on the website. You can undo this at any time.",
    "admin.ban.descUnban": "The player will be able to use the ZaroAI chat on the website again.",
    "admin.ban.reason": "Reason (optional, stored in the audit log)",
    "admin.ban.reasonPlaceholder": "e.g. repeated prompt injection attempts",
    "admin.ban.doneBan": "Player banned.",
    "admin.ban.doneUnban": "Player unbanned.",
    "admin.ban.noProfile": "No linked website profile.",
    "admin.ban.self": "You can't ban yourself.",
    "admin.ban.staff": "Admins and owners can't be banned here.",

    // System health
    "admin.health.title": "System health",
    "admin.health.allGood": "Everything is configured.",
    "admin.health.problems": "{n} items need attention",
    "admin.health.optional": "optional",
    "admin.health.setEnv": "Set {name} in the Vercel environment variables and redeploy.",
    "admin.health.applyMigration": "Run supabase/migrations/{file} in the Supabase SQL Editor.",
    "admin.health.needService": "Can't be checked without SUPABASE_SERVICE_ROLE_KEY.",
    "admin.health.zrsDown": "The server API didn't respond or the server is offline.",
    "admin.health.zrsNotConfigured": "Server API not configured.",
    "admin.health.connectDefault": "No ZRS_CONNECT_ADDRESS: the CONNECT button uses the default address.",
    "admin.health.footer": "Checked at {when} · {ms} ms · region {region} · deploy {deploy}",
    "admin.health.item.supabaseUrl": "Supabase URL",
    "admin.health.item.serviceRole": "Service role key (server)",
    "admin.health.item.zaroKey": "ZaroAI model key",
    "admin.health.item.zrsApi": "ZRS server API",
    "admin.health.item.zrsLive": "ZRS server responding",
    "admin.health.item.alertWebhook": "Alerts webhook (Discord)",
    "admin.health.item.connectOverride": "CONNECT button address",
    "admin.health.item.migAlerts": "Security alerts migration",
    "admin.health.item.migPortal": "Admin portal migration",
    "admin.health.state.ok": "OK",
    "admin.health.state.bad": "Missing",
    "admin.health.state.unknown": "Unknown",
    "admin.health.state.optional": "Optional, not configured",
    "admin.health.err.network": "Couldn't reach the health endpoint.",
    "admin.health.err.unauthorized": "Session expired. Sign out and back in.",
    "admin.health.err.forbidden": "The server refused: your role has no access.",
    "admin.health.err.missing": "Endpoint /api/admin/health unavailable (it only exists on the Vercel deployment).",
    "admin.health.err.rateLimited": "Too many requests. Wait a minute.",
    "admin.health.err.generic": "Couldn't check the system.",

    // Hardening
    "admin.hardening.title": "Hardening checklist",
    "admin.hardening.authLimits": "Supabase Auth rate limits and CAPTCHA",
    "admin.hardening.authLimitsText": "In Authentication → Rate Limits / Attack Protection, enable request limits and CAPTCHA.",
    "admin.hardening.discord2fa": "Discord 2FA for all staff",
    "admin.hardening.discord2faText": "Portal sign-in is Discord-only: without 2FA, a stolen account means access to the panel.",
    "admin.hardening.rotate": "Rotate keys at the first sign of trouble",
    "admin.hardening.rotateText": "Service role, model key, API token and webhook: rotate them if a leak is suspected. Never in REACT_APP_*.",
    "admin.hardening.rls": "RLS on and migrations applied",
    "admin.hardening.rlsText": "Every table uses Row Level Security; the portal path isn't a secret, RLS is the protection.",
    "admin.hardening.leastPrivilege": "As few admins as possible",
    "admin.hardening.leastPrivilegeText": "Only owners change roles. Grant admin only to those who need it and remove it when they leave the staff.",
    "admin.hardening.auditReview": "Review the audit log",
    "admin.hardening.auditReviewText": "Once a week, check bans and role changes in the Audit section.",

    // Players
    "admin.players.title": "Registered players",
    "admin.players.privacy": "Emails are never shown in this panel.",
    "admin.players.search": "Name, username, Discord ID or SteamID",
    "admin.players.filter": "Player filter",
    "admin.players.fAll": "All",
    "admin.players.fStaff": "Staff",
    "admin.players.fBanned": "Banned",
    "admin.players.fSteam": "With Steam",
    "admin.players.empty": "No players found.",
    "admin.players.emptySearch": "Try another term or clear the filters.",
    "admin.players.colPlayer": "Player",
    "admin.players.colRole": "Role",
    "admin.players.colJoined": "Joined",
    "admin.players.colActions": "Actions",
    "admin.players.banned": "Banned",
    "admin.players.changeRole": "Change role",
    "admin.players.roleSelf": "You can't change your own role here.",
    "admin.players.roleTitle": "Change {name}'s role?",
    "admin.players.roleDesc": "From {from} to {to}. It takes effect on the player's next sign-in and is recorded in the audit log.",
    "admin.players.roleWarn": "Admins and owners can see every player's data and ban people. Make sure you trust this person.",
    "admin.players.roleConfirm": "Change role",
    "admin.players.roleChanged": "Role changed to {role}.",
    "admin.players.roleError.last_owner": "You can't remove the last owner.",
    "admin.players.roleError.forbidden": "Only owners can change roles.",
    "admin.players.roleError.service_role_missing": "SUPABASE_SERVICE_ROLE_KEY is missing on the server.",
    "admin.players.roleError.rate_limited": "Too many requests. Wait a minute.",
    "admin.players.roleError.invalid_input": "Invalid request.",
    "admin.players.roleError.update_failed": "Supabase rejected the change.",
    "admin.players.roleError.network": "Couldn't reach the server.",
    "admin.players.roleError.missing": "Endpoint /api/admin/role isn't available in this environment.",
    "admin.players.roleError.generic": "Couldn't change the role.",

    // VIP
    "admin.vip.title": "VIP simulator requests",
    "admin.vip.subtitle": "Amounts estimated by the simulator, in Brazilian reais.",
    "admin.vip.search": "Player or VIP name",
    "admin.vip.empty": "No VIP requests yet.",
    "admin.vip.total": "Requests (all time)",
    "admin.vip.value7d": "Estimated value (7d)",
    "admin.vip.avgPage": "Average ticket (page)",
    "admin.vip.pageSum": "{value} on this page",
    "admin.vip.colTotal": "Estimated total",
    "admin.vip.colBudget": "Budget",
    "admin.vip.colDate": "Date",
    "admin.vip.overBudget": "over budget",
    "admin.vip.expand": "Show request details",
    "admin.vip.collapse": "Hide details",
    "admin.vip.items": "Items ({n})",
    "admin.vip.benefits": "Perks ({n})",
    "admin.vip.more": "+{n} items",
    "admin.vip.noItems": "No items in this request.",
    "admin.vip.noBenefits": "No extra perks.",
    "admin.vip.kitTotal": "Kit",
    "admin.vip.benefitsExtra": "Extra perks",

    // ZaroAI
    "admin.zaro.questions24h": "Questions (24h)",
    "admin.zaro.conversations24h": "New conversations (24h)",
    "admin.zaro.activeUsers": "Active users (7d)",
    "admin.zaro.tokens24h": "Tokens (24h)",
    "admin.zaro.latency": "Average latency (24h)",
    "admin.zaro.trendSub": "{n} questions in the last 14 days",
    "admin.zaro.conversations": "Website conversations",
    "admin.zaro.conversationsSub": "Sorted by most recent activity",
    "admin.zaro.search": "Title or Discord ID",
    "admin.zaro.empty": "No website conversations yet.",
    "admin.zaro.untitled": "Untitled conversation",
    "admin.zaro.startedAt": "Started on {when}",
    "admin.transcript.empty": "No stored messages.",
    "admin.transcript.count": "{n} messages",
    "admin.transcript.tokens": "{n} tokens",
    "admin.transcript.player": "Player",
    "admin.transcript.ipHashHint": "IP hash prefix (never the real IP), useful to link accounts from the same device.",

    // Audit
    "admin.audit.title": "Audit log",
    "admin.audit.subtitle": "Who did what, to whom and when.",
    "admin.audit.filter": "Filter by action",
    "admin.audit.allActions": "All actions",
    "admin.audit.empty": "No actions recorded.",
    "admin.audit.emptyHint": "Bans, alert reviews and role changes show up here.",
    "admin.audit.immutable": "{n} entries · the audit log can't be edited or deleted from the website.",
    "admin.audit.action.ban": "banned",
    "admin.audit.action.unban": "unbanned",
    "admin.audit.action.role_change": "changed the role of",
    "admin.audit.action.alert_reviewed": "reviewed the alert",
    "admin.audit.action.alert_reopened": "reopened the alert",
    "admin.audit.action.alerts_bulk_reviewed": "reviewed several alerts",
    "admin.audit.target.profile": "Profile",
    "admin.audit.target.user": "User",
    "admin.audit.target.security_alert": "Alert",
};

export default { pt, en };
